<template>
	<div class="link-qr-code">
		<div v-if="!link" class="empty-text">暂无可生成的链接</div>
		<canvas v-else ref="canvasRef"></canvas>
	</div>
</template>

<script>
import QRCode from 'qrcode'

export default {
	name: 'LinkQrCode',
	props: {
		link: {
			type: String,
			default: ''
		},
		size: {
			type: Number,
			default: 220
		}
	},
	watch: {
		link: {
			immediate: true,
			handler() {
				this.renderQrCode()
			}
		},
		size() {
			this.renderQrCode()
		}
	},
	methods: {
		renderQrCode() {
			this.$nextTick(() => {
				if (!this.link || !this.$refs.canvasRef) {
					return
				}
				QRCode.toCanvas(
					this.$refs.canvasRef,
					this.link,
					{
						width: this.size,
						margin: 1
					},
					(err) => {
						if (err) {
							this.$message.error('二维码生成失败')
						}
					}
				)
			})
		}
	}
}
</script>

<style scoped>
.link-qr-code {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 120px;
}

.empty-text {
	color: #999;
	font-size: 14px;
}
</style>
